export function Visuals() {
  return (
    <>
      <img
        src="/blob.png"
        className="absolute top-[35%]  max-h-[500px] left-[1%] z-0 opacity-50"
      />
      <img
        src="/blob.png"
        className="absolute top-[20%] max-h-[500px] right-[1%] z-0 opacity-50"
      />
    </>
  )
}
